import { IFilterFormItem } from 'common/types';
import { userGroupsFilter } from 'common/utils/drawerFilters';
import { TReportType } from 'report/types';
import {
    startDateRangeFilter,
    endDateRangeFilter,
    completionDateRangeFilter,
    progressFilter,
    scoreFilter,
    completionStatusFilter,
    scoreThresholdReachedFilter,
} from 'report/utils/filter';

export const getReportFilters = (type: TReportType) => {
    switch (type) {
        case 'training':
            return [
                startDateRangeFilter(),
                userGroupsFilter(),
                progressFilter(),
                scoreFilter(),
                scoreThresholdReachedFilter(),
            ] as IFilterFormItem[];
        case 'course':
            return [
                startDateRangeFilter(),
                completionDateRangeFilter(),
                userGroupsFilter(),
                progressFilter(),
                scoreFilter(),
                completionStatusFilter(),
                scoreThresholdReachedFilter(),
            ] as IFilterFormItem[];
        case 'portfolio':
            return [
                startDateRangeFilter('reportFilters.startDateRangePortfolio'),
                endDateRangeFilter(),
                userGroupsFilter(),
            ] as IFilterFormItem[];
        case 'portfolioTraining':
            return [
                startDateRangeFilter(),
                progressFilter(),
                scoreFilter(),
                scoreThresholdReachedFilter(),
            ] as IFilterFormItem[];
        case 'portfolioOffer':
            return [
                startDateRangeFilter(),
                progressFilter(),
                scoreFilter(),
                scoreThresholdReachedFilter(),
            ] as IFilterFormItem[];
        case 'offer':
            return [
                startDateRangeFilter(),
                userGroupsFilter(),
                progressFilter(),
                scoreFilter(),
                scoreThresholdReachedFilter(),
            ] as IFilterFormItem[];
        // This also takes skill report filters into account
        default:
            return [];
    }
};
